import { render, staticRenderFns } from "./LayoutAbout.vue?vue&type=template&id=453c2cf0&"
import script from "./LayoutAbout.vue?vue&type=script&lang=ts&"
export * from "./LayoutAbout.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutAbout.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VContainer,VMain})
